import { Box, Image } from '@jfs/ui-new'

export const ColorMatrixImage = ({ imgUri, imgStyles }: any) => (
  <Box>
    <Image {...imgStyles} resizeMode="contain" source={imgUri} />
  </Box>
)
